import React from "react";

import AttendanceModule from "./attendanceModule";
import MarketingModule from "./marketingModule";
import PageWithConfigurator from "../global/pageWithConfigurator/pageWithConfigurator";
import MembershipSalesModule from "./membershipSalesModule";
import MembershipRevenueModule from "./membershipRevenueModule";
import MembershipUnitsModule from "./membershipUnitsModule";
import RevenueBreakdownModule from "./revenueBreakdownModule";
import TotalRevenueModule from "./totalRevenueModule";
import LeadsAddedModule from "./leadsAddedModule";
import MembershipModule from "./membershipModule";
import FirstRidersModule from "./firstRidersModule";
import GoalsSummaryModule from "./goalsSummaryModule";
import dashboardFilters from "./dashboardFilters";

const pageConfig = {
  pageName: "Dashboard",
  configuratorWidth: 350,
  pageFilters: [dashboardFilters],
  moduleList: [
    AttendanceModule,
    MarketingModule,
    MembershipSalesModule,
    MembershipRevenueModule,
    MembershipUnitsModule,
    RevenueBreakdownModule,
    TotalRevenueModule,
    LeadsAddedModule,
    MembershipModule,
    FirstRidersModule,
    GoalsSummaryModule
  ]
};

const DashboardPage = ({ notifications }) => {
  const PageFilters = dashboardFilters.Component;

  return (
    <PageWithConfigurator
      pageConfig={pageConfig}
      notifications={notifications}
      renderFilters={() => <PageFilters />}
    />
  );
};

export default DashboardPage;
